// Simple sticky anchor navigation
// Example HTML:
//
// <div data-sticky-nav>
//     <ul data-observe-navigation class="navigation">
//         <li class="navigation__item">
//             <a
//                 href="#linkTargetId"
//                 data-nav-id="linkTargetId"
//                 class="navigation__link">
//                 Link Name
//             </a>
//         </li>
//     </ul>
// </div>
//
// <section id="linkTargetId" data-observe>
//     Section Content
// </section>

import { smoothScrollTo, smoothScrollToWithOffset } from './smoothScrollTo';

const navigationWrappers = document.querySelectorAll('[data-sticky-nav]');

function initStickyNav() {
    if (navigationWrappers.length > 0) {
        navigationWrappers.forEach(element => {
            const navigation = element.querySelector('[data-observe-navigation]');
            const allNavigationItems = navigation.querySelectorAll('[data-nav-id]');
            const sections = document.querySelectorAll('[data-observe]');
            const SCROLL_DURATION_TIME = 1500;
            let isNavStickyOnTop = false;
            let updateNavByClick = false;
            const buttonLeft = document.querySelector('[data-scroll-left]');
            const buttonRight = document.querySelector('[data-scroll-right]');

            if (buttonLeft && buttonRight) {
                if (navigation.scrollWidth > navigation.clientWidth) {
                    buttonRight.setAttribute('data-scroll-right', 'active');
                    navigation.addEventListener('scroll', () => updateNavControlsOnScroll(navigation, buttonLeft, buttonRight));
                } else {
                    buttonRight.setAttribute('data-scroll-right', 'inactive');
                }

                buttonRight.addEventListener(
                    'click', () => sideScroll(navigation, 'right', 25, 200, 20)
                );
                buttonLeft.addEventListener(
                    'click', () => sideScroll(navigation, 'left', 25, 200, 20)
                );
            }

            if (sections.length && !!window.IntersectionObserver) {
                const config = {
                    rootMargin: '0px 0px -80% 0px',
                };

                const observer = new IntersectionObserver(function(entries) {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            updateNavigation(entry);
                        }
                    });
                }, config);

                const stickyObserver = new IntersectionObserver(([entry]) => {
                    isNavStickyOnTop = entry.isIntersecting;
                }, {
                    threshold: 1,
                });
                stickyObserver.observe(navigation);

                if (sections) {
                    sections.forEach(section => {
                        observer.observe(section);
                    });
                }
            }

            allNavigationItems.forEach(anchor => {
                anchor.addEventListener('click', function(e) {
                    e.preventDefault();
                    updateNavByClick = true;

                    const navigationItemData = this.getBoundingClientRect();
                    let distanceFromTop= Math.floor(navigationItemData.height);
                    const containerStyle = element.currentStyle || window.getComputedStyle(element);
                    const containerHeight = this.offsetHeight + parseInt(containerStyle.marginBottom || 20);
                    if (navigationItemData.top !== 0) {
                        distanceFromTop = Math.floor(navigationItemData.height) + containerHeight;
                    }
                    let additionalWhitespace = 16;

                    // PITHP-287 - The following lines can be deleted in case version A wins
                    const topicPageMobileNav = document.querySelector('[data-topic-mobile-nav]');
                    if (topicPageMobileNav) {
                        additionalWhitespace = 40;
                    }

                    smoothScrollToWithOffset(
                        document.querySelector(this.getAttribute('href')),
                        distanceFromTop + additionalWhitespace
                    );
                    setTimeout(() => updateNavByClick = false, SCROLL_DURATION_TIME);
                });
            });

            function updateNavigation(entry) {
                const id = entry.target.id;
                const currentNavigationItem = navigation.querySelector(`[data-nav-id="${ id }"]`);
                if (currentNavigationItem) {
                    if (!updateNavByClick) {
                        const currentNavItemObserver = new IntersectionObserver(([entry]) => {
                            if (!entry.isIntersecting && isNavStickyOnTop) {
                                smoothScrollTo(currentNavigationItem);
                            }
                            currentNavItemObserver.unobserve(entry.target);
                        }, {
                            threshold: 1,
                        });
                        currentNavItemObserver.observe(currentNavigationItem);
                    }
                    allNavigationItems.forEach(item => {
                        item.setAttribute('data-status', 'inactive');
                    });
                    currentNavigationItem.setAttribute('data-status', 'active');
                    if (history.replaceState) {
                        history.replaceState(null, null, `#${ id }`);
                    }
                }
            }

            /* Navigation controls */
            function sideScroll(element, direction, speed, distance, step) {
                let scrollAmount = 0;
                const maxScrollAmount = element.scrollWidth - element.clientWidth;
                const slideTimer = setInterval(() => {
                    element.scrollLeft > step ?
                        buttonLeft.setAttribute('data-scroll-left', 'active') :
                        buttonLeft.setAttribute('data-scroll-left', 'inactive');
                    element.scrollLeft >= maxScrollAmount ?
                        buttonRight.setAttribute('data-scroll-right', 'inactive') :
                        buttonRight.setAttribute('data-scroll-right', 'active');
                    if (direction === 'left'){
                        element.scrollLeft -= step;
                    } else {
                        element.scrollLeft += step;
                    }
                    scrollAmount += step;
                    if (scrollAmount >= distance){
                        window.clearInterval(slideTimer);
                    }
                }, speed);
            }

            function updateNavControlsOnScroll(navElement, buttonLeft, buttonRight) {
                const NOT_SCROLLED_WIDTH = 0;
                const scrolledAmount = navElement.scrollLeft;
                const maxScrollAmount = navElement.scrollWidth - navElement.clientWidth;
                const hasNotScrolled = scrolledAmount === NOT_SCROLLED_WIDTH;
                const hasFullyScrolled = scrolledAmount === maxScrollAmount;

                if (hasNotScrolled) {
                    buttonLeft.setAttribute('data-scroll-left', 'inactive');
                    buttonRight.setAttribute('data-scroll-right', 'active');
                } else if (hasFullyScrolled) {
                    buttonLeft.setAttribute('data-scroll-left', 'active');
                    buttonRight.setAttribute('data-scroll-right', 'inactive');
                } else {
                    buttonLeft.setAttribute('data-scroll-left', 'active');
                    buttonRight.setAttribute('data-scroll-right', 'active');
                }
            }
        });
    }
}

export { initStickyNav };
